import { Routes } from '@angular/router';
import { PrivateLayoutComponent } from './shared/layout/private-layout/private-layout.component';
import { authGuard } from './core/guards/private/auth.guard';
import { menuAccessGuard } from './core/guards/private/menu-access.guard';
import { loginGuard } from './core/guards/public/login.guard';

import { DashboardComponent } from './pages/private/dashboard/dashboard.component';
import { DashboardParkingComponent } from './pages/private/dashboard/dashboard-parking/dashboard-parking.component';
import { DashboardParkingOpsComponent } from './pages/private/dashboard/dashboard-parking-ops/dashboard-parking-ops.component';
import { DashboardParkingFinanceComponent } from './pages/private/dashboard/dashboard-parking-finance/dashboard-parking-finance.component';
import { RegisterMemberComponent } from './pages/private/out-category/register-member/register-member.component';
import { LoginComponent } from './pages/public/login/login.component';
import { StampApproveComponent } from './pages/private/out-category/stamp-approve/stamp-approve.component';
import { CouponGenerateComponent } from './pages/private/out-category/coupon-generate/coupon-generate.component';
import { VehicleCardFutureDetailsComponent } from './pages/private/out-category/vehicle-card-future-details/vehicle-card-future-details.component';
import { CouponParkingListComponent } from './pages/private/out-category/coupon-parking/coupon-parking-list/coupon-parking-list.component';
import { CouponParkingListDetailsComponent } from './pages/private/out-category/coupon-parking/coupon-parking-list-details/coupon-parking-list-details.component';
import { DiscountCardComponent } from './pages/private/out-category/discount-card/discount-card.component';
import { DiscountCardDetailsComponent } from './pages/private/out-category/discount-card-details/discount-card-details.component';
import { DiscountActiveComponent } from './pages/private/out-category/discount-active/discount-active.component';
import { StampDiscountDetailsComponent } from './pages/private/out-category/stamp-discount-details/stamp-discount-details.component';
import { ParkingTransactionEvComponent } from './pages/private/out-category/parking-transaction-ev/parking-transaction-ev.component';
import { InvoiceListComponent } from './pages/private/finance/invoice/invoice-list/invoice-list.component';
import { InvoiceTestComponent } from './pages/private/finance/invoice/invoice-test/invoice-test.component';
import { ModalInvoiceFulltaxComponent } from './pages/private/modals/finance/invoice/modal-invoice-fulltax/modal-invoice-fulltax.component';
import { ParkingFinanceComponent } from './pages/private/finance/parking-finance/parking-finance.component';
import { ParkingShiftComponent } from './pages/private/finance/parking-shift/parking-shift.component';
import { BankAccountsComponent } from './pages/private/finance/bank-accounts/bank-accounts.component';

import { GenerateEvQrComponent } from './pages/private/in-category/ev-charger/generate-ev-qr/generate-ev-qr.component';

import { VehicleCardFutureComponent } from './pages/private/out-category/vehicle-card-future/vehicle-card-future.component';
import { StampDiscountComponent } from './pages/private/out-category/stamp-discount/stamp-discount.component';
import { EvChargerListComponent } from './pages/private/in-category/ev-charger/ev-charger-list/ev-charger-list.component';
import { CustomerManagementComponent } from './pages/private/cityparking/manage-customer/customer-management/customer-management.component';
import { VehicleListComponent } from './pages/private/in-category/vehicle/vehicle-list/vehicle-list.component';
import { InvoiceDetailComponent } from './pages/private/finance/invoice/invoice-detail/invoice-detail.component';
import { TransactionParkingComponent } from './pages/private/parking/transactions/transaction-parking/transaction-parking.component';
import { VehiclesInParkingComponent } from './pages/private/parking/transactions/vehicles-in-parking/vehicles-in-parking.component';
import { LineOaMemberComponent } from './pages/private/cityparking/line-oa/line-oa-member/line-oa-member.component';
import { RegisterMemberListComponent } from './pages/private/cityparking/register-member/register-member-list/register-member-list.component';
import { RegisterMemberMarketingComponent } from './pages/private/cityparking/register-member-marketing/register-member-marketing.component';
import { RevenueMarketingComponent } from './pages/private/finance/revenue-marketing/revenue-marketing.component';
import { RegisterParkingComponent } from './pages/private/parking/register-parking/register-parking.component';
import { RevenueAddComponent } from './pages/private/finance/revenue/revenue-add/revenue-add.component';
import { ManageFeeComponent } from './pages/private/finance/master-fee/manage-fee/manage-fee.component';
import { ManageFeeGroupComponent } from './pages/private/finance/master-fee/manage-fee-group/manage-fee-group.component';
import { ManageSubscriptionComponent } from './pages/private/finance/master-fee/manage-subscription/manage-subscription.component';
import { ParkingCardsComponent } from './pages/private/parking/parking-cards/parking-cards.component';
import { ParkingCardsBulkDatesComponent } from './pages/private/parking/parking-cards-bulk-dates/parking-cards-bulk-dates.component';
import { ParkingCardsTaiwanPendingComponent } from './pages/private/parking/parking-cards-taiwan-pending/parking-cards-taiwan-pending.component';
import { ParkingCardsDeletedComponent } from './pages/private/parking/parking-cards-deleted/parking-cards-deleted.component';
import { MembershipPackagesComponent } from './pages/private/parking/membership-packages/membership-packages.component';
import { PrestampTaiwanComponent } from './pages/private/parking/discount/prestamp-taiwan/prestamp-taiwan.component';
import { TaiwanDiscountComponent } from './pages/private/parking/discount/taiwan-discount/taiwan-discount.component';
import { StampGroupComponent } from './pages/private/parking/discount/stamp-group/stamp-group.component';
import { StampAmountMapComponent } from './pages/private/parking/discount/stamp-amount-map/stamp-amount-map.component';
import { StampReceiptComponent } from './pages/private/parking/discount/stamp-receipt/stamp-receipt.component';
import { StampMembersComponent } from './pages/private/parking/discount/stamp-members/stamp-members.component';
import { StampApplyComponent } from './pages/private/parking/discount/stamp-apply/stamp-apply.component';
import { StampBillableChargeComponent } from './pages/private/parking/discount/stamp-billable-charge/stamp-billable-charge.component';
import { WebStampHistoryComponent } from './pages/private/parking/discount/web-stamp-history/web-stamp-history.component';
import { DiscountFreeRangeComponent } from './pages/private/parking/discount/free-range/discount-free-range.component';
import { LocalFeeCalcTestComponent } from './pages/private/parking/local-fee-calc-test/local-fee-calc-test.component';
import { ParkingMainRateComponent } from './pages/private/system-settings/parking-main-rate/parking-main-rate.component';
import { ParkingSubRateComponent } from './pages/private/system-settings/parking-sub-rate/parking-sub-rate.component';
import { ParkingPenaltyRateComponent } from './pages/private/system-settings/parking-penalty-rate/parking-penalty-rate.component';
import { ProviderParkingsComponent } from './pages/private/in-category/provider-parking/provider-parkings/provider-parkings.component';
import { ProviderSiteComponent } from './pages/private/in-category/provider-parking/provider-site/provider-site.component';
import { ProviderGroupSpotComponent } from './pages/private/in-category/provider-parking/provider-group-spot/provider-group-spot.component';
import { ProviderSpotComponent } from './pages/private/in-category/provider-parking/provider-spot/provider-spot.component';
import { FineComponent } from './pages/private/finance/fine/fine/fine.component';
import { FloorTenantCompanyComponent } from './pages/private/in-category/provider-parking/floor-tenant-company/floor-tenant-company.component';
import { ParkingTypeComponent } from './pages/private/parking/parking-type/parking-type.component';
import { ParkingZoneComponent } from './pages/private/parking/parking-zone/parking-zone.component';
import { TenantCompanyComponent } from './pages/private/in-category/tenant-company/tenant-company/tenant-company.component';
import { GroupMenusComponent } from './pages/private/system-settings/group-menus/group-menus.component';
import { GroupSubMenusComponent } from './pages/private/system-settings/group-sub-menus/group-sub-menus.component';
import { MenuListsComponent } from './pages/private/system-settings/menu-lists/menu-lists.component';
import { ManageUsersComponent } from './pages/private/system-settings/manage-users/manage-users.component';
import { ManageRolesComponent } from './pages/private/system-settings/manage-roles/manage-roles.component';
import { ManageRolesMenuComponent } from './pages/private/system-settings/manage-roles-menu/manage-roles-menu.component';
import { SettingQuotaCardComponent } from './pages/private/system-settings/setting-quota-card/setting-quota-card.component';
import { SettingCardTypeConfigComponent } from './pages/private/system-settings/setting-card-type-config/setting-card-type-config.component';
import { SettingInvoiceComponent } from './pages/private/system-settings/setting-invoice/setting-invoice.component';
import { SettingInvoiceFeeComponent } from './pages/private/system-settings/setting-invoice-fee/setting-invoice-fee.component';
import { ApprovalConfigComponent } from './pages/private/system-settings/approval-config/approval-config.component';
import { ParkingVehicleTypeComponent } from './pages/private/system-settings/parking-vehicle-type/parking-vehicle-type.component';
import { ParkingAreaComponent } from './pages/private/system-settings/parking-area/parking-area.component';
import { ParkingCardTypeComponent } from './pages/private/system-settings/parking-card-type/parking-card-type.component';
import { ParkingCardModeComponent } from './pages/private/system-settings/parking-card-mode/parking-card-mode.component';
import { ParkingPaymentLogComponent } from './pages/private/system-settings/parking-payment-log/parking-payment-log.component';
import { AdminActivityLogComponent } from './pages/private/system-settings/admin-activity-log/admin-activity-log.component';
import { LiffHomeMenuComponent } from './pages/private/system-settings/liff-home-menu/liff-home-menu.component';
import { LineGuideMenuComponent } from './pages/private/system-settings/line-guide-menu/line-guide-menu.component';
import { PublicGuidesComponent } from './pages/private/system-settings/public-guides/public-guides.component';
import { SitePublicProfilesComponent } from './pages/private/system-settings/site-public-profiles/site-public-profiles.component';
import { LineBroadcastsComponent } from './pages/private/system-settings/line-broadcasts/line-broadcasts.component';
import { SiteFreeQuotaComponent } from './pages/private/system-settings/site-free-quota/site-free-quota.component';
import { UserSiteAccessComponent } from './pages/private/system-settings/user-site-access/user-site-access.component';
import { ParkingGateTypeComponent } from './pages/private/system-settings/parking-gate-type/parking-gate-type.component';
import { ParkingGateComponent } from './pages/private/system-settings/parking-gate/parking-gate.component';
import { ParkingGateGroupComponent } from './pages/private/system-settings/parking-gate-group/parking-gate-group.component';
import { ParkingRateComponent } from './pages/private/system-settings/parking-rate/parking-rate.component';
import { EvPriceRatesComponent } from './pages/private/system-settings/ev-price-rates/ev-price-rates.component';
import { EvConnectorTypesComponent } from './pages/private/system-settings/ev-connector-types/ev-connector-types.component';
import { LineRichMenuComponent } from './pages/private/system-settings/line-rich-menu/line-rich-menu.component';
import { EvStationMonitorComponent } from './pages/private/cityparking/ev-station-monitor/ev-station-monitor.component';
import { EvChargingJobsComponent } from './pages/private/cityparking/ev-charging-jobs/ev-charging-jobs.component';
import { NewsManagementComponent } from './pages/private/cityparking/news-management/news-management.component';
import { NewsCategoriesComponent } from './pages/private/cityparking/news-categories/news-categories.component';
import { RegisterMemberCardComponent } from './pages/private/cityparking/register-member-card/register-member-card.component';
import { QuotaRequestsComponent } from './pages/private/card-quota/quota-requests/quota-requests.component';
import { ClientQuotasComponent } from './pages/private/card-quota/client-quotas/client-quotas.component';
import { QuotaAllocationComponent } from './pages/private/card-quota/quota-allocation/quota-allocation.component';
import { PlatformCardsComponent } from './pages/private/card-quota/platform-cards/platform-cards.component';
import { QuotaCardAdvancesComponent } from './pages/private/card-quota/quota-card-advances/quota-card-advances.component';
import { BuildingFreeQuotaComponent } from './pages/private/card-quota/building-free-quota/building-free-quota.component';
import { AccessGroupsComponent } from './pages/private/system-settings/access-groups/access-groups.component';
import { FreeParkingDashboardComponent } from './pages/private/card-quota/free-parking-dashboard/free-parking-dashboard.component';
import { FreeParkingAdvancesComponent } from './pages/private/card-quota/free-parking-advances/free-parking-advances.component';
import { CardAdvancesComponent } from './pages/private/cityparking/card-advances/card-advances.component';
import { TopUpComponent } from './pages/private/cityparking/top-up/top-up.component';
import { ApprovalInboxComponent } from './pages/private/approval/approval-inbox/approval-inbox.component';
import { ApprovalHistoryComponent } from './pages/private/approval/approval-history/approval-history.component';
import { AccessDeniedComponent } from './pages/private/access-denied/access-denied.component';
import { ParkingSiteComponent } from './pages/private/parking/master/parking-site/parking-site.component';
import { ParkingClientComponent } from './pages/private/parking/master/parking-client/parking-client.component';
import { FullTaxReportComponent } from './pages/private/report/full-tax-report/full-tax-report.component';
import { RegisterMemberPaymentReportComponent } from './pages/private/report/register-member-payment-report/register-member-payment-report.component';
import { Rpfi05Component } from './pages/private/report/rpfi05/rpfi05.component';
import { Rpfi09Component } from './pages/private/report/rpfi09/rpfi09.component';
import { Rpfi13Component } from './pages/private/report/rpfi13/rpfi13.component';
import { Rpfi01Component } from './pages/private/report/rpfi01/rpfi01.component';
import { Rpfi26Component } from './pages/private/report/rpfi26/rpfi26.component';
import { Rppk01Component } from './pages/private/report/rppk01/rppk01.component';
import { Rppk15Component } from './pages/private/report/rppk15/rppk15.component';
import { Rppk14Component } from './pages/private/report/rppk14/rppk14.component';
import { Rppk16Component } from './pages/private/report/rppk16/rppk16.component';
import { Rpfi15Component } from './pages/private/report/rpfi15/rpfi15.component';
import { Rpfi17Component } from './pages/private/report/rpfi17/rpfi17.component';
import { CustomerServiceIssueTypeComponent } from './pages/private/customer-services/customer-service-issue-type/customer-service-issue-type.component';
import { CustomerServiceCaseComponent } from './pages/private/customer-services/customer-service-case/customer-service-case.component';

export const appRoutes: Routes = [
  {
    path: '',
    component: PrivateLayoutComponent,
    canActivate: [authGuard],
    canActivateChild: [menuAccessGuard],
    children: [
      {
        path: 'access-denied',
        component: AccessDeniedComponent,
        data: { skipMenuGuard: true },
      },

      /* ================= path_id menu routes (see mapper-user-menu.service.ts) ================= */
      { path: 'dashboard', component: DashboardComponent },
      { path: 'dashboard-parking', component: DashboardParkingComponent },
      { path: 'dashboard-parking-ops', component: DashboardParkingOpsComponent },
      { path: 'dashboard-parking-finance', component: DashboardParkingFinanceComponent },
      { path: 'system-settings/group-menus', component: GroupMenusComponent },
      { path: 'system-settings/group-sub-menus', component: GroupSubMenusComponent },
      { path: 'system-settings/menu-lists', component: MenuListsComponent },
      { path: 'system-settings/manage-users', component: ManageUsersComponent },
      { path: 'system-settings/manage-roles', component: ManageRolesComponent },
      { path: 'system-settings/manage-roles-menus', component: ManageRolesMenuComponent },
      { path: 'system-settings/setting-quota-card', component: SettingQuotaCardComponent },
      { path: 'system-settings/setting-card-type-config', component: SettingCardTypeConfigComponent },
      { path: 'system-settings/setting-invoice', component: SettingInvoiceComponent },
      { path: 'system-settings/setting-invoice-fee', component: SettingInvoiceFeeComponent },
      { path: 'system-settings/approval-config', component: ApprovalConfigComponent },
      { path: 'system-settings/parking-vehicle-type', component: ParkingVehicleTypeComponent },
      { path: 'system-settings/parking-card-type', component: ParkingCardTypeComponent },
      { path: 'system-settings/parking-card-mode', component: ParkingCardModeComponent },
      { path: 'system-settings/parking-payment-log', component: ParkingPaymentLogComponent },
      { path: 'system-settings/activity-log', component: AdminActivityLogComponent },
      { path: 'system-settings/liff-home-menu', component: LiffHomeMenuComponent },
      { path: 'system-settings/line-guide-menu', component: LineGuideMenuComponent },
      { path: 'system-settings/public-guides', component: PublicGuidesComponent },
      { path: 'system-settings/site-public-profiles', component: SitePublicProfilesComponent },
      { path: 'system-settings/line-broadcasts', component: LineBroadcastsComponent },
      { path: 'system-settings/site-free-quota', component: SiteFreeQuotaComponent },
      { path: 'system-settings/user-site-access', component: UserSiteAccessComponent },
      { path: 'system-settings/access-groups', component: AccessGroupsComponent },
      { path: 'system-settings/parking-gate-type', component: ParkingGateTypeComponent },
      { path: 'system-settings/parking-gate', component: ParkingGateComponent },
      { path: 'system-settings/parking-gate-group', component: ParkingGateGroupComponent },
      { path: 'system-settings/parking-rate', component: ParkingRateComponent },
      { path: 'system-settings/parking-main-rate', component: ParkingMainRateComponent },
      { path: 'system-settings/parking-sub-rate', component: ParkingSubRateComponent },
      { path: 'system-settings/parking-penalty-rate', component: ParkingPenaltyRateComponent },
      { path: 'system-settings/parking-area', component: ParkingAreaComponent },
      { path: 'system-settings/ev-price-rates', component: EvPriceRatesComponent },
      { path: 'system-settings/ev-connector-types', component: EvConnectorTypesComponent },
      { path: 'system-settings/line-rich-menu', component: LineRichMenuComponent },
      { path: 'card-quota/quota-requests', component: QuotaRequestsComponent },
      { path: 'card-quota/client-quotas', component: ClientQuotasComponent },
      { path: 'card-quota/quota-allocation', component: QuotaAllocationComponent },
      { path: 'card-quota/platform-cards', component: PlatformCardsComponent },
      { path: 'card-quota/quota-card-advances', component: QuotaCardAdvancesComponent },
      { path: 'card-quota/building-free-quota', component: BuildingFreeQuotaComponent },
      { path: 'card-quota/free-parking-dashboard', component: FreeParkingDashboardComponent },
      { path: 'card-quota/free-parking-cards', component: ParkingCardsComponent },
      { path: 'card-quota/free-parking-advances', component: FreeParkingAdvancesComponent },
      { path: 'cityparking/card-advances', component: CardAdvancesComponent },
      { path: 'cityparking/top-up', component: TopUpComponent },
      { path: 'approval/inbox', component: ApprovalInboxComponent },
      { path: 'approval/history', component: ApprovalHistoryComponent },
      { path: 'cityparking/line-oa-member', component: LineOaMemberComponent },
      { path: 'cityparking/register-member', component: RegisterMemberListComponent },
      { path: 'cityparking/register-member-marketing', component: RegisterMemberMarketingComponent },
      { path: 'cityparking/customer-management', component: CustomerManagementComponent },
      { path: 'cityparking/ev-charger-list', component: EvChargerListComponent },
      { path: 'cityparking/ev-station-monitor', component: EvStationMonitorComponent },
      { path: 'cityparking/ev-charging-jobs', component: EvChargingJobsComponent },
      { path: 'cityparking/news-management', component: NewsManagementComponent },
      { path: 'cityparking/news-categories', component: NewsCategoriesComponent },
      { path: 'cityparking/register-member-card', component: RegisterMemberCardComponent },
      { path: 'cityparking/vehicle-list', component: VehicleListComponent },
      { path: 'parking/transaction-parking', component: TransactionParkingComponent },
      { path: 'parking/vehicles-in-parking', component: VehiclesInParkingComponent },
      { path: 'parking/parking-site', component: ParkingSiteComponent },
      { path: 'parking/parking-client', component: ParkingClientComponent },
      { path: 'parking/parking-cards', component: ParkingCardsComponent },
      { path: 'parking/parking-cards-bulk-dates', component: ParkingCardsBulkDatesComponent },
      { path: 'parking/parking-cards-taiwan-pending', component: ParkingCardsTaiwanPendingComponent },
      { path: 'parking/parking-cards-deleted', component: ParkingCardsDeletedComponent },
      { path: 'parking/membership-packages', component: MembershipPackagesComponent },
      { path: 'parking/discount/prestamp-taiwan', component: PrestampTaiwanComponent },
      { path: 'parking/discount/taiwan-discount', component: TaiwanDiscountComponent },
      { path: 'parking/discount/stamp-group', component: StampGroupComponent },
      { path: 'parking/discount/stamp-amount-map', component: StampAmountMapComponent },
      { path: 'parking/discount/stamp-receipt', component: StampReceiptComponent },
      { path: 'parking/discount/stamp-members', component: StampMembersComponent },
      { path: 'parking/discount/stamp-apply', component: StampApplyComponent },
      { path: 'parking/discount/stamp-billable-charge', component: StampBillableChargeComponent },
      { path: 'parking/discount/web-stamp-history', component: WebStampHistoryComponent },
      { path: 'parking/discount/free-range', component: DiscountFreeRangeComponent },
      { path: 'parking/local-fee-calc-test', component: LocalFeeCalcTestComponent },
      { path: 'finance/invoice-list', component: InvoiceListComponent },
      { path: 'finance/revenue-add', component: RevenueAddComponent },
      { path: 'finance/manage-fee', component: ManageFeeComponent },
      { path: 'finance/manage-fee-group', component: ManageFeeGroupComponent },
      { path: 'finance/manage-subscription', component: ManageSubscriptionComponent },
      { path: 'finance/parking-finance', component: ParkingFinanceComponent },
      { path: 'finance/revenue-marketing', component: RevenueMarketingComponent },
      { path: 'finance/parking-shift', component: ParkingShiftComponent },
      { path: 'finance/bank-accounts', component: BankAccountsComponent },
      { path: 'parking/register-parking', component: RegisterParkingComponent },
      { path: 'test', component: InvoiceTestComponent },

      // ================================ Report ================================
      { path: 'report/full-tax-report', component: FullTaxReportComponent },
      { path: 'report/register-member-payment', component: RegisterMemberPaymentReportComponent },
      { path: 'report/rpfi05', component: Rpfi05Component },
      { path: 'report/rpfi09', component: Rpfi09Component },
      { path: 'report/rpfi13', component: Rpfi13Component },
      { path: 'report/rpfi01', component: Rpfi01Component },
      { path: 'report/rpfi26', component: Rpfi26Component },
      { path: 'report/rppk01', component: Rppk01Component },
      { path: 'report/rppk15', component: Rppk15Component },
      { path: 'report/rppk14', component: Rppk14Component },
      { path: 'report/rppk16', component: Rppk16Component },
      { path: 'report/rpfi15', component: Rpfi15Component },
      { path: 'report/rpfi17', component: Rpfi17Component },
      /* ================= legacy / detail routes (not in path_id map yet) ================= */
      {
        path: 'stamp-approve',
        component: StampApproveComponent,
      },
      // --------- Coupon Generate ---------
      {
        path: 'coupon-generate',
        component: CouponGenerateComponent,
      },
      // --------- Register Member ---------
      {
        path: 'register-member',
        component: RegisterMemberComponent,
      },
      // --------- Vehicle Card Future ---------
      {
        path: 'vehicle-card-future',
        component: VehicleCardFutureComponent,
      },
      {
        path: 'vehicle-card-future-detail',
        component: VehicleCardFutureDetailsComponent,
      },
      {
        path: 'vehicle-card-future-detail/:id',
        component: VehicleCardFutureDetailsComponent,
      },
      // --------- Coupon Parking List ---------
      {
        path: 'coupon-parking-list',
        component: CouponParkingListComponent,
      },
      {
        path: 'coupon-parking-list-details/:id',
        component: CouponParkingListDetailsComponent,
      },
      // ================================ Discount Card ================================
      {
        path: 'discount-card',
        component: DiscountCardComponent,
      },
      {
        path: 'discount-card-details',
        component: DiscountCardDetailsComponent,
      },
      {
        path: 'discount-card-details/:id',
        component: DiscountCardDetailsComponent,
      },
      {
        path: 'discount-active',
        component: DiscountActiveComponent,
      },
      // ================================ Stamp Discount ================================
      {
        path: 'stamp-discount',
        component: StampDiscountComponent,
      },
      {
        path: 'stamp-discount-details',
        component: StampDiscountDetailsComponent,
      },
      {
        path: 'stamp-discount-details/:id',
        component: StampDiscountDetailsComponent,
      },
      // ================================ Search ================================

      // ================================ EV ================================
      {
        path: 'ev-list',
        component: EvChargerListComponent,
      },
      {
        path: 'parking-transaction-ev',
        component: ParkingTransactionEvComponent,
      },
      {
        path: 'generate-ev-qr',
        component: GenerateEvQrComponent,
      },
      /* =============================== Register Parking =============================== */
      // {
      //   path: 'register-parking',
      //   component: RegisterParkingComponent,
      // },

      /* =============================== Provider Parking =============================== */
      {
        path: 'provider-parking',
        component: ProviderParkingsComponent,
      },
      {
        path: 'provider-site',
        component: ProviderSiteComponent,
      },
      {
        path: 'provider-group',
        component: ProviderGroupSpotComponent,
      },
      {
        path: 'provider-spot',
        component: ProviderSpotComponent,
      },
      {
        path: 'floor-tenant-company',
        component: FloorTenantCompanyComponent,
      },
      /* =============================== Tenant Company =============================== */
      {
        path: 'tenant-company',
        component: TenantCompanyComponent,
      },

      /* =============================== Parking =============================== */
      {
        path: 'parking-type',
        component: ParkingTypeComponent,
      },
      {
        path: 'parking-zone',
        component: ParkingZoneComponent,
      },

      /* =============================== Finance =============================== */

      {
        path: 'invoice-detail',
        component: InvoiceDetailComponent,
      },
      {
        path: 'invoice-detail/:id',
        component: InvoiceDetailComponent,
      },
      {
        path: 'invoice-fulltax/:id',
        component: ModalInvoiceFulltaxComponent,
      },

      {
        path: 'fine-list',
        component: FineComponent,
      },
      /* =============================== Customer Service =============================== */
      {
        path: 'customer-service/customer-service-issue-type',
        component: CustomerServiceIssueTypeComponent,
      },
      {
        path: 'customer-service/customer-service-case',
        component: CustomerServiceCaseComponent,
      },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    ],
  },
  {
    path: 'login',
    canActivate: [loginGuard],
    component: LoginComponent,
  },

  { path: '**', redirectTo: 'login' },
];
